import { MAJOR_ARCANA } from '@lunary/tarot-data'
import type { MergePreviewResponseDto } from '@lunary/api-client'
import { LOGIN_METHOD_LABELS, loginMethodsLabel, roleLabel } from './labels'
import styles from './merge-dialog.module.css'

const WARNING_TEXT: Readonly<Record<string, string>> = {
  source_email_dropped: 'Email второго аккаунта не сохранится: у этого профиля уже есть свой.',
  pending_order_rejected: 'У обоих есть разбор в очереди. Разбор второго аккаунта будет отклонён.',
  duplicates_dropped: 'Записи за одни и те же дни останутся только у этого профиля.',
}

function arcanaLabel(id: number | null): string {
  if (id === null) return 'не указан'
  return MAJOR_ARCANA.find((c) => c.number === id)?.name ?? String(id)
}

export function MergePreview({ preview }: { preview: MergePreviewResponseDto }) {
  const { source, moves, result } = preview
  const facts: [string, string][] = [
    ['Удаляется', source.display_name ?? source.email ?? 'Без имени'],
    ['Способы входа переедут', loginMethodsLabel(preview.source_methods)],
    ['Карты дня', String(moves.daily_readings)],
    ['Разборы арканов', String(moves.arcana_orders)],
    ['Выборы трёх карт', String(moves.picks)],
    ['Отзывы', String(moves.feedback)],
    ['Дни активности', String(moves.activity_days)],
    ['Имя после', result.display_name ?? 'нет'],
    ['Email после', result.email ?? 'нет'],
    ['Роль после', roleLabel(result.role)],
    ['Личный аркан после', arcanaLabel(result.arcana_id)],
  ]
  return (
    <>
      <dl className={styles.facts}>
        {facts.map(([k, v]) => (
          <div key={k} className={styles.row}>
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
      </dl>
      {preview.conflicts.length > 0 && (
        <p className="error-box" role="alert">
          У обоих аккаунтов есть {preview.conflicts.map((c) => LOGIN_METHOD_LABELS[c] ?? c).join(', ')}. Сначала отвяжите
          его у одного из них.
        </p>
      )}
      {preview.warnings.length > 0 && (
        <ul className={styles.warnings}>
          {preview.warnings.map((w) => (
            <li key={w}>{WARNING_TEXT[w] ?? w}</li>
          ))}
        </ul>
      )}
    </>
  )
}
